import React, { useState } from 'react';
import SupplierPartDetailScreen from './SupplierPartDetailScreen';
import SupplierPartModal from '@/js/components/modals/SupplierPartModal';

const data = [
  {
    id: '#RFQ-001',
    buyerName: 'ABC',
    partName: 'Pen Casing',
    quantity: 1000,
    leadTime: '30 Days',
    budget: '$1,000',
    deadline: '12/02/25',
    status: 'Pending',
    action: 'View',
  },
  {
    id: '#RFQ-002',
    buyerName: 'ABC',
    partName: 'Pen Casing',
    quantity: 1000,
    leadTime: '30 Days',
    budget: '$2,000',
    deadline: '12/02/25',
    status: 'Under review',
    action: ['Submit Quote', 'view'],
  },
  {
    id: '#RFQ-003',
    buyerName: 'ABC',
    partName: 'Pen Casing',
    quantity: 1000,
    leadTime: '30 Days',
    budget: '$3,000',
    deadline: '12/02/25',
    status: 'Quote Sent',
    action: 'Track',
  },
];

const RFQDashboard = () => {
  const [sortBy, setSortBy] = useState(null);
  const [isAscending, setIsAscending] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [tableData, setTableData] = useState(data);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleSort = (sortKey) => {
    if (sortKey === sortBy) {
      setIsAscending(!isAscending);
    } else {
      setSortBy(sortKey);
      setIsAscending(false);
    }

    const sortedData = [...data].sort((a, b) => {
      if (sortKey === 'budget') {
        const budgetA = Number(a.budget.replace(/[^0-9.-]+/g, ''));
        const budgetB = Number(b.budget.replace(/[^0-9.-]+/g, ''));
        return isAscending ? budgetA - budgetB : budgetB - budgetA;
      }
      return 0;
    });

    setTableData(sortedData);
    setIsDropdownOpen(false);
  };
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-bold text-lg">RFQ List & Status</h2>
        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="flex items-center gap-2 rounded-md px-6 py-1.5 bg-gray-100 text-sm text-gray-700 hover:bg-gray-50"
          >
            {sortBy ? `Budget ${isAscending ? '↑' : '↓'}` : 'Sort By'}
            <svg
              className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
              <div className="py-1">
                <button
                  onClick={() => handleSort('budget')}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Budget
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="py-4">
        <table className="w-full border-separate border-spacing-y-4">
          <thead>
            <tr className="text-gray-600 text-sm text-left">
              <th className="px-4 pt-2 whitespace-nowrap font-thin text-center">
                RFQ ID
              </th>
              <th className="px-4 pt-2 text-center font-thin">BuyerName</th>
              <th className="px-4 pt-2 whitespace-nowrap text-center font-thin">
                Part Name
              </th>
              <th className="px-4 pt-2 font-thin">Quantity</th>
              <th className="px-4 pt-2 text-center font-thin">
                Lead Time <br /> Requested
              </th>
              <th className="px-4 pt-2 font-thin">Budget</th>
              <th className="px-4 pt-2 text-center font-thin">
                Quote Submission <br /> Deadline
              </th>
              <th className="px-4 pt-2 font-thin">Status</th>
              <th className="px-4 pt-2 font-thin">Action</th>
            </tr>
            <tr>
              <td
                colSpan="9"
                className="border-t border-black-300 h-px p-0"
              ></td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <tr
                key={index}
                className="bg-gray-50 text-sm text-gray-700 mb-4 overflow-hidden"
              >
                <td className="py-7 px-2 text-center text-darkPurple rounded-l-lg">
                  {item.id}
                </td>
                <td className="py-4 px-2 text-center">{item.buyerName}</td>
                <td className="py-4 px-2 text-center">{item.partName}</td>
                <td className="py-4 px-2 text-center">{item.quantity}</td>
                <td className="py-4 px-2 text-center">{item.leadTime}</td>
                <td className="py-4 px-2 text-center">{item.budget}</td>
                <td className="py-4 px-2 text-center">{item.deadline}</td>
                <td className="py-4 px-2 text-center">
                  {item.status.toLocaleLowerCase() === 'under review' ? (
                    <div className="flex flex-col leading-tight">
                      <span>Under</span>
                      <span>Review</span>
                    </div>
                  ) : (
                    <span>{item.action}</span>
                  )}
                </td>
                <td className="p-2 text-center rounded-r-lg">
                  {Array.isArray(item.action) ? (
                    <div className="flex flex-col gap-2 justify-center">
                      {item.action.map((action, i) => (
                        <button
                          key={i}
                          className={`px-1.5 py-0.5 rounded text-xs ${
                            action === 'Submit Quote'
                              ? 'bg-white text-darkerPurple border border-darkerPurple'
                              : 'text-darkerPurple'
                          }`}
                        >
                          {action}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <button className="bg-white border border-darkerPurple text-darkerPurple px-3 py-0.5 rounded text-xs">
                      {item.action}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RFQDashboard;
